<script setup>
import { trans } from '@elements/translation';
import { EVENT_SLIDERS } from '../../general/event-constants';

const emit = defineEmits([ 'openModal' ]);

const emitClick = () => {
  emit('openModal', {
    title: trans('gestion.invoices.slider.update_subscription.title'),
    name: EVENT_SLIDERS.MODIFY_SUBSCRIPTION,
  });
};
</script>

<template>
  <li @click="emitClick">
    <span>{{ trans('gestion.subscription.end') }}</span>
  </li>
</template>
